// extracted by mini-css-extract-plugin
module.exports = {"icon":"Detail_icon__3l3CY","iconDis":"Detail_iconDis__xnIsf"};